/**
 * ExamTimer Component
 * Displays the exam timer with warning states
 */
import { Clock, AlertTriangle } from 'lucide-react';
import { formatTime } from './examConfig';

const ExamTimer = ({ timeRemaining, showWarning = false }) => {
  const isLowTime = timeRemaining <= 300; // 5 minutes or less
  
  return (
    <div className={`flex items-center gap-2 px-4 py-2 rounded-lg font-mono text-lg ${
      isLowTime 
        ? 'bg-red-100 dark:bg-red-950/30 text-red-600' 
        : 'bg-slate-100 dark:bg-slate-800'
    }`}>
      {isLowTime ? (
        <AlertTriangle className="w-5 h-5" />
      ) : (
        <Clock className="w-5 h-5 text-slate-500" />
      )}
      <span className="font-bold">{formatTime(timeRemaining)}</span>
    </div>
  );
};

export default ExamTimer;
